import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
    selector: 'app-row-expander',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <button type="button"
                class="btn btn-link btn-sm expander-btn"
                [attr.aria-expanded]="expanded"
                [attr.aria-controls]="controlsId || null"
                [attr.aria-label]="(expanded ? collapseLabel : expandLabel)"
                [attr.data-testid]="testId || 'row-expander'"
                (click)="onToggle($event)">
            <i class="fa"
               [class.fa-chevron-right]="!expanded"
               [class.fa-chevron-down]="expanded"></i>
        </button>
    `,
    styles: [`
        .expander-btn {
            padding: 0 .5rem;
            color: inherit;
            text-decoration: none;
            border: 0;
            background: transparent;
        }
        .expander-btn:focus-visible {
            outline: 2px solid #2563eb;
            outline-offset: 2px;
            border-radius: 4px;
        }
        .expander-btn .fa {
            font-size: .85em;
        }
    `]
})
export class RowExpanderComponent {
    @Input() expanded = false
    @Input() controlsId: string | null = null
    @Input() testId: string | null = null
    @Input() expandLabel = 'Expand'
    @Input() collapseLabel = 'Collapse'
    @Output() toggled = new EventEmitter<void>()

    onToggle(ev: MouseEvent): void {
        ev.preventDefault()
        ev.stopPropagation()
        this.toggled.emit()
    }
}
